import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
interface ChecklistProps {
  items: string[];
}
export function Checklist({
  items
}: ChecklistProps) {
  const [checked, setChecked] = useState<number[]>([]);
  const toggle = (index: number) => {
    setChecked(current => current.includes(index) ? current.filter(value => value !== index) : [...current, index]);
  };
  return <div className="my-8 border-y-2 border-forest bg-forest-soft px-5 py-6 sm:px-7" data-id="element-23" data-mp="14ubf9qo3ynbs">
      <h3 className="font-sans text-xs font-bold uppercase tracking-widest text-forest-mid" data-id="element-24" data-mp="102b9vip9r27t">
        The escape-risk checklist she walked me through
      </h3>
      <ul className="mt-4 space-y-1" data-id="element-25" data-mp="vylo10zzayqh">
        {items.map((item, index) => {
        const isChecked = checked.includes(index);
        return <li key={item} data-id="element-26" data-mp="m1quyxmh5qjl" data-mpi={index}>
              <button type="button" onClick={() => toggle(index)} aria-pressed={isChecked} className="flex w-full items-start gap-3 rounded px-2 py-2 text-left transition-colors duration-150 ease-out hover:bg-white/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest" data-id="element-27" data-mp="m20mipn645re">
                <span className={['mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded border-2 transition-colors duration-150 ease-out', isChecked ? 'border-forest bg-forest text-white' : 'border-forest-mid/50 bg-white text-transparent'].join(' ')} data-id="element-28" data-mp="4ei28l3xvcvz">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-29" data-mp="n9gj5rfwhtxu" />
                </span>
                <span className="font-sans text-[17px] leading-relaxed text-ink" data-id="element-30" data-mp="s89vhgjgbewf">
                  {item}
                </span>
              </button>
            </li>;
      })}
      </ul>
      <p aria-live="polite" className="mt-4 border-t border-forest-line pt-4 font-sans text-sm font-semibold text-forest" data-id="element-31" data-mp="3cubhkwmjaibg">
        {checked.length === 0 ? 'Tick the ones that sound like your dog.' : `You checked ${checked.length} of ${items.length} — she told me even one means your dog is at risk every day you wait.`}
      </p>
    </div>;
}